import { IconProps } from '../icon';

export function HouseIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_151_113)">
        <path
          d="M32 14.8929V29.9034C31.9988 30.3719 31.8682 30.8316 31.6219 31.2341C31.3756 31.6367 31.0227 31.9673 30.6 32.1914C30.2124 32.3995 29.7759 32.5058 29.3333 32.4998H21.3333C20.9797 32.4998 20.6406 32.363 20.3905 32.1195C20.1405 31.8761 20 31.5459 20 31.2016V23.4124C20 23.0681 19.8595 22.7379 19.6095 22.4944C19.3594 22.2509 19.0203 22.1142 18.6667 22.1142H13.3334C12.9797 22.1142 12.6406 22.2509 12.3905 22.4944C12.1405 22.7379 12 23.0681 12 23.4124V31.2016C12 31.5459 11.8595 31.8761 11.6095 32.1195C11.3594 32.363 11.0203 32.4998 10.6667 32.4998H2.6667C2.28841 32.5012 1.9142 32.4237 1.56922 32.2725C1.22425 32.1214 0.916512 31.9001 0.666699 31.6235C0.233192 31.1248 -0.00321838 30.4918 3.30978e-05 29.8385V14.8929C0.000150674 14.5327 0.0772641 14.1764 0.226469 13.8468C0.375675 13.5171 0.593707 13.2213 0.866699 12.9781L14.2 1.18073C14.6916 0.742845 15.3337 0.5 16 0.5C16.6663 0.5 17.3084 0.742845 17.8 1.18073L31.1333 12.9781C31.4063 13.2213 31.6244 13.5171 31.7736 13.8468C31.9228 14.1764 31.9999 14.5327 32 14.8929Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_151_113">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HouseIcon;
